import styled, { DefaultTheme, css } from 'styled-components';

type WrapperProps = {
  variant: 'primary' | 'secondary';
};

const wrapperModifiers = (theme: DefaultTheme) => ({
  primary: css`
    background-color: ${theme.colors.brandPrimary10};
    border: 1px solid ${theme.colors.brandPrimary30};
    border-radius: 8px;
    font-size: 1.4rem;
    font-weight: 500;
    color: ${theme.colors.brandPrimary100};
    padding: 0 16px;
  `,
  secondary: css`
    background-color: ${theme.colors.neutralGray100};
    border-radius: 100px;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.2;
    color: ${theme.colors.globalWhite100};
    padding: 4px 8px;
  `,
});

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, variant }) => css`
    display: inline-block;

    ${wrapperModifiers(theme)[variant]}
  `}
`;
